import validate from "/opt/suncore/build/20261103T154933Z-259fdf9d/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/opt/suncore/build/20261103T154933Z-259fdf9d/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/opt/suncore/build/20261103T154933Z-259fdf9d/app/middleware/auth.js")
}